import { render, staticRenderFns } from "./choseApplications.vue?vue&type=template&id=be041d32&scoped=true"
import script from "./choseApplications.vue?vue&type=script&lang=js"
export * from "./choseApplications.vue?vue&type=script&lang=js"
import style0 from "./choseApplications.vue?vue&type=style&index=0&id=be041d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be041d32",
  null
  
)

export default component.exports